import { render, staticRenderFns } from "./ReferLogin.vue?vue&type=template&id=6f39c3a8&scoped=true&"
import script from "./ReferLogin.vue?vue&type=script&lang=js&"
export * from "./ReferLogin.vue?vue&type=script&lang=js&"
import style0 from "./ReferLogin.vue?vue&type=style&index=0&id=6f39c3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39c3a8",
  null
  
)

export default component.exports